export const onlyLettersAndSpaces = (
  input: string | number | undefined | null
): string => {
  if (!input) return "";
  return input.toString().replace(/[^a-zA-Z\s]/g, "");
};
